export const handleSharesIncrement = async (
  setArticleStats: any,
  pageData: any,
  articleUrl: string
) => {
  const incrementCountRequest = await fetch("/api/articles/update-stats", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Cache-Control": "no-store",
    },
    body: JSON.stringify({
      articleId: pageData?.articleId,
      type: "shares",
      articleUrl,
    }),
  });
  const incrementCountResponse = await incrementCountRequest.json();
  setArticleStats(incrementCountResponse?.updatedDateShareReview);
};

export const incrementReadCount = async (
  setArticleStats: any,
  pageData: any,
  articleUrl: string
) => {
  const incrementCountRequest = await fetch("/api/articles/update-stats", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Cache-Control": "no-store",
    },
    body: JSON.stringify({
      articleId: pageData?.articleId,
      type: "reads",
      articleUrl,
    }),
  });
  const incrementCountResponse = await incrementCountRequest.json();
  setArticleStats(incrementCountResponse?.updatedDateShareReview);
};
